export type PartyRole = {
  code: string
  labelPl: string
  sortOrder: number
  isActive: boolean
}

export type ContractParty = {
  id: number
  customerId: number
  customerName: string
  roleCode: string
  roleLabelPl: string
}

/** Kod roli jedynego obowiązkowego aktora - zamawiającego. */
export const ROLE_ORDERER = 'zamawiajacy'
